export const messageGroupLabel = "a6Pdo";
export const meetingRequestGroupLabel = "$_ayAe";
export const meetingCancelationGroupLabel = "$axjib";
export const meetingDeclineGroupLabel = "eIHzz";
export const meetingAcceptanceGroupLabel = "tEz$fe";
export const meetingTentativeAcceptanceGroupLabel = "v$cZLd";
export const automaticReplyGroupLabel = "MvBgfe";
export const undeliveredReportGroupLabel = "wDjMhc";
export const otherGroupLabel = "pb_lHb";
export default {messageGroupLabel,meetingRequestGroupLabel,meetingCancelationGroupLabel,meetingDeclineGroupLabel,meetingAcceptanceGroupLabel,meetingTentativeAcceptanceGroupLabel,automaticReplyGroupLabel,undeliveredReportGroupLabel,otherGroupLabel};